'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _combineStyles = require('../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = function root(image) {
  var defaultImage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var overrideStyle = arguments[2];

  var style = (0, _combineStyles2.default)(_styles2.default.root, { backgroundImage: 'url(' + image + ')' });

  if (defaultImage) {
    style = (0, _combineStyles2.default)(style, { backgroundImage: 'url(' + image + '), url(' + defaultImage + ')' });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var status = function status(type, overrideStyle) {
  var style = _styles2.default.status;
  var backgroundColor = void 0;

  switch (type) {
    case 'online':
      backgroundColor = _colors2.default.online;
      break;
    case 'away':
      backgroundColor = _colors2.default.away;
      break;
    case 'offline':
      backgroundColor = _colors2.default.offline;
      break;
    default:
      backgroundColor = _colors2.default.offline;
  }

  style = (0, _combineStyles2.default)(style, { backgroundColor: backgroundColor });

  return (0, _combineStyles2.default)(style, overrideStyle);
};

exports.default = {
  root: root,
  status: status
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/avatar/get-styles.js
// module id = 749
// module chunks = 0